const messages = {
  title: 'Access Denied',
  description: 'You have no access to this resource',
  backHomeButton: 'Back To Dashboard'
}

export default {
  messages
}
